<template>
  <div>

    <div class="h-panel">
      <b-button v-if="mayEditPlayerData" :to="{name: 'player_inventory_edit'}">
        Edit
      </b-button>
    </div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="inventoryItems !== null && inventoryItems.length > 0" class="table text-nowrap inventory-table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product</th>
          <th scope="col" class="text-right">Amount</th>
          <th scope="col" v-if="mayEditPlayerData">Actions</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="item in inventoryItems">
        <tr :key="item.id">
          <td>{{item.protoId | getProtoAlias}}</td>
          <td class="text-right">{{item.amount | getFormattedNumber}}</td>
          <td v-if="mayEditPlayerData" class="action-group">
            <b-button
              :to="{name: 'player_inventory_item_edit', params: {playerId: playerId, itemId: item.id}}"
              size="sm"
            >
              Edit
            </b-button>
          </td>
        </tr>
        </template>
      </tbody>
    </table>

  </div>
</template>

<script>
import auth from '../auth.js';
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

/**
 * @typedef { import("../model/player_inventory.js").InventoryItem } InventoryItem
 */
import { compareInventoryItems } from '../model/player_inventory.js';

import { mayEditPlayerData as utilMayEditPlayerData } from '../util.js';

import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerInventory',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      actor: auth.getViewer(),

      /** @type {boolean} */
      isLoading: false,

      /** @type {?InventoryItem[]} */
      inventoryItems: null,
    };
  },

  computed: {
    /** @returns {?string} */
    message() {
      if(this.inventoryItems !== null && this.inventoryItems.length === 0) {
        return 'Inventory is empty.';
      }
      return null;
    },

    /** @returns {boolean} */
    mayEditPlayerData() {
      return utilMayEditPlayerData(this.actor.role);
    },
  },

  created() {
    this.loadInventory();
  },

  methods: {
    loadInventory() {
      this.isLoading = true;

      const url = '/player/' + this.playerId + '/inventory';
      HTTP.get(url)
      .then(response => {
        this.isLoading = false;

        /** @type {InventoryItem[]} */
        const inventoryItems = response.data.data;
        inventoryItems.sort(compareInventoryItems);

        this.inventoryItems = inventoryItems;
      })
      .catch(err => {
        this.isLoading = false;
        notifier.showError(err);
      });
    },
  },
};
</script>

<style scoped>
.inventory-table .btn {
  padding-top:    0.1rem;
  padding-bottom: 0.1rem;
  padding-left:  0.4rem;
  padding-right: 0.4rem;
}

.action-group {
  padding-top:    0.5rem;
  padding-bottom: 0.5rem;
  vertical-align: middle;
}
</style>
